export const FolderSortService = Symbol('FolderSortService');
